module.exports = __webpack_public_path__ + "img/ft-resize-plus.67b74e3e.svg";